import { useEffect, useReducer } from 'react';
import axios from 'axios';

const EVENT = 'adeeb-categories-change';

let cache = [];
let loaded = false;
let inflight = null;

function emit() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENT));
}

export async function loadCategories(force = false) {
  if (loaded && !force) return cache;
  if (inflight) return inflight;
  inflight = axios
    .get('/api/categories', { timeout: 6000 })
    .then(({ data }) => {
      cache = Array.isArray(data) ? data : [];
      loaded = true;
      emit();
      return cache;
    })
    .catch(() => {
      cache = [];
      loaded = true;
      emit();
      return cache;
    })
    .finally(() => { inflight = null; });
  return inflight;
}

// "Adventure & Faith" → "adventure-faith"  (URL-friendly id used as the active-tag key)
export function categorySlug(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function useCategories() {
  const [, force] = useReducer((x) => x + 1, 0);
  useEffect(() => {
    if (!loaded) loadCategories();
    const onChange = () => force();
    window.addEventListener(EVENT, onChange);
    return () => window.removeEventListener(EVENT, onChange);
  }, []);
  return cache;
}
